import styled from 'styled-components';

import { StarBall } from 'atoms/icons/StarBall';

export const SmallerStarBall = styled(StarBall)`
  width: 28px;
`;
